import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAllPlacesFromGroupUseCaseInterface } from 'domain/usecases';

export class RemoteGetAllPlacesFromGroup
  implements GetAllPlacesFromGroupUseCaseInterface
{
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAllPlacesFromGroupUseCaseInterface.Result>,
  ) {}

  async execute(
    params: GetAllPlacesFromGroupUseCaseInterface.Params,
  ): Promise<GetAllPlacesFromGroupUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: `${this.url}/${params.groupId}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
